// Single customer-facing guard for store phone actions.
// demo-store is a public product demo and must never expose a callable number.
export function getStoreCallHref(storeId, phone) {
  if (storeId === "demo-store") return null;

  let digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) digits = digits.slice(2);
  if (!/^[6-9]\d{9}$/.test(digits)) return null;
  return `tel:+91${digits}`;
}
